import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@shared/models/page-event';
import { finalize } from 'rxjs/operators';
import Utils from '@shared/utils/utils';
import { ApiService } from '@shared/apis';
import { SpinnerService } from '@shared/services/spinner.service';
import { AuthService } from '@core/auth/auth.service';
import { Options } from '@shared/models/options';
import { PagedResponse } from '@shared/models/paged-response';
import { TicketInfo } from '@shared/models/ticket-info';
import * as _ from 'lodash-es';
import Swal from 'sweetalert2';
import { EventService } from '@shared/services/event.service';
import Roles from '@shared/constants/roles';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit {

  q: any;
  query: any;
  filter: any;

  tickets: TicketInfo[] = [];
  pagedResponse: PagedResponse;

  isAllChecked = false;
  isAdmin = false;

  constructor(private spinnerService: SpinnerService,
              private authService: AuthService,
              private eventService: EventService,
              private apiService: ApiService,) {
    this.isAdmin = this.authService.hasType(Roles.admin);
  }

  ngOnInit(): void {
    this.showList();
  }

  onPageEvent(pageEvent: PageEvent) {
    this.showList(pageEvent);
  }

  showList(pageEvent?: PageEvent) {
    this.isAllChecked = false;
    this.filter = {
      ticketNo: { $regex: '\D', $options: 'i' },
    };

    this.spinnerService.start('table');
    this.apiService.ticket.getTickets(pageEvent, this.options())
      .pipe(finalize(() => this.spinnerService.stop('table')))
      .subscribe(res => {
        this.pagedResponse = res;
        this.tickets = res.docs;
        this.eventService.selectTickets$.next([]);
      }, err => Utils.showError(err));
  }

  options() {
    const opt: Options = {
      q: this.q,
      query: this.query,
      filter: this.filter,
      sort: '-postingDate',
    };
    return opt;
  }

  repairCost(pricing, type) {
    if (!pricing) {
      return 0;
    }

    const parts = pricing?.parts ? Number(pricing?.parts[type]) || 0 : 0;
    const labor = pricing?.labor ? Number(pricing?.labor[type]) || 0 : 0;
    return parts + labor;
  }

  selectAll() {
    this.tickets.map(m => {
      if (m.customerPayment !== 'SENT') {
        m.isChecked = !this.isAllChecked;
      }
    });
    this.isAllChecked = !this.isAllChecked;
    this.setSelectTickets();
  }

  changeCheckBoxStatus(e, field) {
    if (e.target.tagName === 'BUTTON' || field.customerPayment === 'SENT') {
      return;
    }

    field.isChecked = !field.isChecked;
    this.isAllChecked = _.every(this.tickets, ['isChecked', true]);
    this.setSelectTickets();
  }

  setSelectTickets() {
    const tickets = this.tickets.filter(f => f.isChecked);
    this.eventService.selectTickets$.next(tickets)
  }

  send($event: MouseEvent, ticket: TicketInfo) {
    Swal.fire({
      title: 'Please enter payment link email.',
      icon: 'info',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Send',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        const email = result.value;
        if (Utils.validateEmail(email)) {
          const params = {
            email,
            ticketNo: ticket.ticketNo
          }

          this.spinnerService.start();
          this.apiService.ticket.sendPaymentLink(params)
            .pipe(finalize(() => this.spinnerService.stop()))
            .subscribe(() => {
              this.showList();
            }, err => Utils.showError(err));
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Invalid email!',
          })
        }
      }
    })
  }

  resend($event: MouseEvent, ticket: TicketInfo) {
    const { ticketNo } = ticket;
    this.spinnerService.start();
    this.apiService.ticket.resendPaymentLink(ticketNo)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(() => {
        this.showList();
      }, err => Utils.showError(err));
  }

  sendCancel($event: MouseEvent, ticket: TicketInfo) {
    const { ticketNo } = ticket;
    this.spinnerService.start();
    this.apiService.ticket.cancelPaymentLink(ticketNo)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(() => {
        this.showList();
      }, err => Utils.showError(err));
  }
}
